import CreateTicket from "../components/CreateTicket";

export default function CreateTicketPage() {
    return (
        <div>
            <CreateTicket />
        </div>
    )
}